import { useQuery } from '@tanstack/react-query';

import { getEmployeeDetails } from './employees';

export const EMPLOYEE_DETAILS_KEY = 'EmployeeDetails';

export const useGetEmployeeDetails = (userId: string | null | undefined) => {
  return useQuery({
    queryKey: [EMPLOYEE_DETAILS_KEY, userId],
    queryFn: () => getEmployeeDetails(userId!),
    enabled: !!userId,
  });
};
